import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/styles';
import {
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Divider,
    Button,
    TextField, FormHelperText
} from '@material-ui/core';
import {updateUserPassword} from '../../../../apis/api';
import validate from 'validate.js';
import formSchema from '../../../../common/formSchema';

const useStyles = makeStyles(() => ({
    root: {}
}));

const schema = {
    ...formSchema,
    confirmPassword: {
        ...formSchema.confirmPassword,
        equality: 'updatePassword'
    }
};

const Password = props => {
    const {className, ...rest} = props;
    const MESSAGE = {
        SUCCESS: '비밀번호 변경이 완료되었습니다.',
        FAIL: '비밀번호가 틀렸습니다. 다시 시도해 주시기 바랍니다.',
        SAME_PASSWORD: '변경 할 비밀번호와 현재 비밀번호가 같습니다.',
        CHECK_FIELD: '필수 항목을 모두 입력해주세요.',
        CHECK_CONFIRM_PASSWORD: '변경 할 비밀번호와 확인 비밀번호가 같지 않습니다. 다시 입력해주세요.'
    };
    const classes = useStyles();

    const [formState, setFormState] = useState({
        isValid: false,
        values: {},
        touched: {},
        errors: {}
    });

    useEffect(() => {
        const errors = validate(formState.values, schema);

        setFormState(formState => ({
            ...formState,
            isValid: !errors,
            errors: errors || {}
        }));
    }, [formState.values]);

    const handleChange = event => {
        event.persist();

        setFormState(formState => ({
            ...formState,
            values: {
                ...formState.values,
                [event.target.name]:
                    event.target.type === 'checkbox'
                        ? event.target.checked
                        : event.target.value
            },
            touched: {
                ...formState.touched,
                [event.target.name]: event.target.value !== ''
            }
        }));
    };

    const errorHandler = () => {
        alert(MESSAGE.FAIL);
    };

    const handleUpdate = event => {
        event.preventDefault();

        const {values} = formState;
        const {password, updatePassword, confirmPassword} = values;

        if (!password || !updatePassword || !confirmPassword) {
            alert(MESSAGE.CHECK_FIELD);
            return;
        }

        if (password === updatePassword) {
            alert(MESSAGE.SAME_PASSWORD);
            return;
        }

        if (updatePassword !== confirmPassword) {
            alert(MESSAGE.CHECK_CONFIRM_PASSWORD);
            return;
        }

        const updatePasswordValue = {
            current_password: password,
            new_password: updatePassword
        };

        updateUserPassword(updatePasswordValue)
            .then(res => {
                if (res.isPasswordChanged) {
                    alert(MESSAGE.SUCCESS);
                    return;
                }
                alert(MESSAGE.FAIL);
            }).catch(() => {
                errorHandler();
            });
    };

    const hasError = field => !!(formState.touched[field] && formState.errors[field]);

    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <form onSubmit={handleUpdate}>
                <CardHeader
                    subheader="Update password"
                    title="Password"
                />
                <Divider/>
                <CardContent>
                    <TextField
                        error={hasError('password')}
                        fullWidth
                        helperText={
                            hasError('password') ? formState.errors.password[0] : null
                        }
                        label="Password"
                        name="password"
                        onChange={handleChange}
                        type="password"
                        value={formState.values.password || ''}
                        variant="outlined"
                    />
                    <TextField
                        error={hasError('updatePassword')}
                        fullWidth
                        helperText={
                            hasError('updatePassword') ? formState.errors.updatePassword[0] : null
                        }
                        label="Update Password"
                        name="updatePassword"
                        onChange={handleChange}
                        style={{marginTop: '1rem'}}
                        type="password"
                        value={formState.values.updatePassword || ''}
                        variant="outlined"
                    />
                    <FormHelperText>
                        6~14자 영문 대 소문자, 숫자, 특수문자를 사용하세요.
                    </FormHelperText>
                    <TextField
                        error={hasError('confirmPassword')}
                        fullWidth
                        helperText={
                            hasError('confirmPassword') ? formState.errors.confirmPassword[0] : null
                        }
                        label="Confirm Password"
                        name="confirmPassword"
                        onChange={handleChange}
                        style={{marginTop: '1rem'}}
                        type="password"
                        value={formState.values.confirmPassword || ''}
                        variant="outlined"
                    />
                </CardContent>
                <Divider/>
                <CardActions>
                    <Button
                        color="primary"
                        variant="outlined"
                        type="submit"
                    >
                        Update
                    </Button>
                </CardActions>
            </form>
        </Card>
    );
};

Password.propTypes = {
    className: PropTypes.string
};

export default Password;
